(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tab-collection-product-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
  const select = event.target.closest('aphros-product-card .card-variant-select-input');
  if (!select) return;
  const card = select.closest('aphros-product-card');
  const option = select.selectedOptions[0];
  const button = card.querySelector('button[name="add"]');
  if (!option || !button) return;
  const unavailable = option.dataset.unavailable === 'true';
  card.querySelector('[name="quantity"]').value = option.dataset.min;
  button.disabled = unavailable;
  button.removeAttribute('aria-disabled');
  button.querySelector('span').textContent = unavailable ? button.dataset.soldLabel : button.dataset.addLabel;
  const price = card.querySelector('.card-price');
  price.replaceChildren();
  if (!unavailable && option.dataset.comparePrice) {
    const oldPrice = document.createElement('span');
    oldPrice.className = 'price-old';
    oldPrice.textContent = option.dataset.comparePrice;
    price.append(oldPrice);
  }
  const currentPrice = document.createElement('span');
  currentPrice.className = unavailable ? 'price-sold-out' : 'price-regular';
  currentPrice.textContent = unavailable ? button.dataset.soldLabel : option.dataset.price;
  price.append(currentPrice);
  card.querySelector('.card-badge--sold-out').hidden = !unavailable;
  card.querySelector('.card-badge--sale').hidden = unavailable || !option.dataset.comparePrice;
  card.querySelector('product-form')?.handleErrorMessage?.();
});
  } catch(e) { console.error(e); }
})();

})();
